<template>
  <div class="archivesWeather">
    <div class="div-fixed">
      <div class="header">
        <div class="title">
          <ul>
            <li id="title-icon">
              <div></div>
              <span>年次レポート / {{ year }} 年 / 天気</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="button-area">
        <span class="btn-submit" @click="excelDownload" v-if="allData.rowData"
          >Excelダウンロード</span
        >
      </div>
      <select v-if="loadedRange" v-model="selectRange" @change="updateRange">
        <option
          v-for="range in displayRange"
          v-bind:key="range.key"
          v-bind:value="range.value"
        >
          {{ range.display }}
        </option>
      </select>
    </div>
    <div class="chart-container">
      <div id="chart-layoutx1">
        <div class="chart-area">
          <p class="ic-thermo">気温</p>
          <LineChart
            class="chart-container-canvas"
            ref="lineChartTemp"
            v-if="loadedTemp"
            :chartData="chartdataTemp"
            :options="optionsTemp"
          ></LineChart>
        </div>
        <div class="chart-area">
          <p class="ic-water-level">降水量</p>
          <LineChart
            class="chart-container-canvas"
            ref="lineChartWater"
            v-if="loadedWater"
            :chartData="chartdataWater"
            :options="optionsWater"
          ></LineChart>
        </div>
        <div class="chart-area">
          <p class="ic-windy">風速</p>
          <LineChart
            class="chart-container-canvas"
            ref="lineChartWindy"
            v-if="loadedWindy"
            :chartData="chartdataWindy"
            :options="optionsWindy"
          ></LineChart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import XLSX from "xlsx";
import LineChart from "@/components/WeatherChartLine.vue";
import Loader from "@/mixins/loader";

export default {
  components: {
    LineChart,
  },

  mixins: [Loader],

  props: {},

  data() {
    return {
      selectRange: 0,
      displayRange: [
        { key: 0, value: 0, display: "年間", from: 0, to: 0 },
        { key: 1, value: 1, display: "1月", from: 0, to: 0 },
        { key: 2, value: 2, display: "2月", from: 0, to: 0 },
        { key: 3, value: 3, display: "3月", from: 0, to: 0 },
        { key: 4, value: 4, display: "4月", from: 0, to: 0 },
        { key: 5, value: 5, display: "5月", from: 0, to: 0 },
        { key: 6, value: 6, display: "6月", from: 0, to: 0 },
        { key: 7, value: 7, display: "7月", from: 0, to: 0 },
        { key: 8, value: 8, display: "8月", from: 0, to: 0 },
        { key: 9, value: 9, display: "9月", from: 0, to: 0 },
        { key: 10, value: 10, display: "10月", from: 0, to: 0 },
        { key: 11, value: 11, display: "11月", from: 0, to: 0 },
        { key: 12, value: 12, display: "12月", from: 0, to: 0 },
      ],
      year:null,
      loadedRange: false,
      loadedTemp: false,
      loadedWindy: false,
      loadedWater: false,
      allData: {
        rowData: null,
        labels: [],
        temp: {
          data: {
            avg: [],
            low: [],
            high: [],
          },
        },
        water: {
          data: {
            avg: [],
            max: [],
            min: [],
          },
        },
        windy: {
          data: {
            avg: [],
            max: [],
            min: [],
          },
        },
      },
      chartdataTemp: {
        labels: [],
        datasets: [
          {
            label: "平均気温（℃）",
            data: [],
            fill: false,
            type: "line",
            lineTension: 0,
            backgroundColor: "rgba(10, 150, 70, 0.3)",
            borderColor: "rgba(10, 150, 70, 0.5)",
            pointBackgroundColor: "rgba(0, 0, 0, 0)",
            pointBorderColor: "rgba(0, 0, 0, 0)",
            pointHoverBackgroundColor: "rgba(10, 150, 70, 0.5)",
          },
          {
            label: "最低気温（℃）",
            data: [],
            fill: false,
            type: "line",
            lineTension: 0,
            backgroundColor: "rgba(90, 30, 233, 0.3)",
            borderColor: "rgba(90, 30, 233, 0.5)",
            pointBackgroundColor: "rgba(0, 0, 0, 0)",
            pointBorderColor: "rgba(0, 0, 0, 0)",
            pointHoverBackgroundColor: "rgba(90, 30, 233, 0.5)",
          },
          {
            label: "最高気温（℃）",
            data: [],
            fill: false,
            type: "line",
            lineTension: 0,
            backgroundColor: "rgba(233, 30, 99, 0.3)",
            borderColor: "rgba(233, 30, 99, 0.5)",
            pointBackgroundColor: "rgba(0, 0, 0, 0)",
            pointBorderColor: "rgba(0, 0, 0, 0)",
            pointHoverBackgroundColor: "rgba(233, 30, 99, 0.5)",
          },
        ],
      },
      chartdataWater: {
        labels: [],
        datasets: [
          {
            label: "最大降水量（mm/h）",
            data: [],
            fill: false,
            type: "bar",
            lineTension: 0,
            backgroundColor: "rgba(90, 30, 233, 0.5)",
            borderColor: "rgba(90, 30, 233, 0.7)",
          },
        ],
      },
      chartdataWindy: {
        labels: [],
        datasets: [
          {
            label: "最大瞬間風速（m/s）",
            data: [],
            fill: false,
            type: "line",
            lineTension: 0,
            backgroundColor: "rgba(10, 150, 70, 0.3)",
            borderColor: "rgba(10, 150, 70, 0.5)",
            pointBackgroundColor: "rgba(0, 0, 0, 0)",
            pointBorderColor: "rgba(0, 0, 0, 0)",
            pointHoverBackgroundColor: "rgba(10, 150, 70, 0.5)",
          },
        ],
      },
      optionsTemp: {
        responsive: true,
        maintainAspectRatio: false,
        height: "250px",
        legend: {
          display: true,
        },
        chartArea: {
          backgroundColor: "#fff",
        },
        scales: {
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "[ ℃ ]",
                fontSize: 13,
              },
              ticks: {
                beginAtZero: true,
                fontSize: 14,
              },
              // id: 'bar-axes',
              position: "left",
            },
          ],
          xAxes: [
            {
              ticks: {
                // beginAtZero: true,
                fontSize: 11,
                source: "auto",
                maxRotation: 60,
                // min: "8/3"
              },
            },
          ],
        },
        // responsive: true, //レスポンシブ
        // maintainAspectRatio: false, //縦横
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        plugins: {
          zoom: {
            // Container for pan options
            pan: {
              // Boolean to enable panning
              enabled: false,

              // Panning directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow panning in the y direction
              mode: "xy",
            },

            // Container for zoom options
            zoom: {
              // Boolean to enable zooming
              enabled: false,

              // Zooming directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow zooming in the y direction
              mode: "xy",
            },
          },
        },
      },
      optionsWater: {
        responsive: true,
        maintainAspectRatio: false,
        height: "250px",
        legend: {
          display: true,
        },
        chartArea: {
          backgroundColor: "#fff",
        },
        scales: {
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "[ mm/h ]",
                fontSize: 13,
              },
              ticks: {
                beginAtZero: true,
                fontSize: 14,
              },
              // id: 'bar-axes',
              position: "left",
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontSize: 11,
                source: "auto",
                maxRotation: 60,
              },
              barPercentage: 1, //棒グラフ幅
              categoryPercentage: 1, //棒グラフ幅
              // id: 'bar-axes-X',
            },
          ],
        },
        // responsive: true, //レスポンシブ
        // maintainAspectRatio: false, //縦横
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        plugins: {
          zoom: {
            // Container for pan options
            pan: {
              // Boolean to enable panning
              enabled: false,

              // Panning directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow panning in the y direction
              mode: "xy",
            },

            // Container for zoom options
            zoom: {
              // Boolean to enable zooming
              enabled: false,

              // Zooming directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow zooming in the y direction
              mode: "xy",
            },
          },
        },
      },
      optionsWindy: {
        responsive: true,
        maintainAspectRatio: false,
        height: "250px",
        legend: {
          display: true,
        },
        chartArea: {
          backgroundColor: "#fff",
        },
        scales: {
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true,
                labelString: "[ m/s ]",
                fontSize: 13,
              },
              ticks: {
                beginAtZero: true,
                fontSize: 14,
              },
              // id: 'bar-axes',
              position: "left",
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontSize: 11,
                source: "auto",
                maxRotation: 60,
              },
              // id: 'bar-axes-X',
            },
          ],
        },
        // responsive: true, //レスポンシブ
        // maintainAspectRatio: false, //縦横
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        plugins: {
          zoom: {
            // Container for pan options
            pan: {
              // Boolean to enable panning
              enabled: false,

              // Panning directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow panning in the y direction
              mode: "xy",
            },

            // Container for zoom options
            zoom: {
              // Boolean to enable zooming
              enabled: false,

              // Zooming directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow zooming in the y direction
              mode: "xy",
            },
          },
        },
      },
    };
  },

  async mounted() {
    this.$emit("hideMap");
    this.loading(async () => {
      this.year = await this.getCurrentYear();
      await this.createData();
      this.loadedRange = true;
    });
  },

  methods: {
    ...mapActions(["retrieveWeatherHistories"]),
    ...mapGetters(["getHistories", "getCurrentYear"]),

    /** 年間データダウンロード */
    excelDownload() {
      let from = this.displayRange[0].from;
      let to = this.displayRange[0].to;
      var ws_data = [
        [
          "日付",
          "最低気温（℃）",
          "平均気温（℃）",
          "最高気温（℃）",
          "最大降水量（mm/h）",
          "最大瞬間風速（m/s）",
        ],
      ];
      for (let i = from; i < to; i++) {
        let rowValue = [];
        rowValue.push(this.year + "/" + this.allData.labels[i]);
        rowValue.push(this.allData.temp.data.low[i]);
        rowValue.push(this.allData.temp.data.avg[i]);
        rowValue.push(this.allData.temp.data.high[i]);
        rowValue.push(this.allData.water.data.max[i]);
        rowValue.push(this.allData.windy.data.max[i]);
        ws_data.push(rowValue);
      }

      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      var wb_out = XLSX.write(wb, { type: "binary" });

      let dt = new Date();
      var blob = new Blob([this.s2ab(wb_out)], {
        type: "application/octet-stream",
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download =
        "RiceLog_" +
        this.year +
        "_weather_" +
        this.getStringFromDate(dt) +
        ".xlsx";
      link.click();
    },

    /** Dateから YYYYMMDDhhmmss 形式に変換して返す */
    getStringFromDate(date) {
      var year_str = date.getFullYear();
      var month_str = date.getMonth() + 1;
      var day_str = date.getDate();
      var hour_str = date.getHours();
      var minute_str = date.getMinutes();
      var second_str = date.getSeconds();

      month_str = ("0" + month_str).slice(-2);
      day_str = ("0" + day_str).slice(-2);
      hour_str = ("0" + hour_str).slice(-2);
      minute_str = ("0" + minute_str).slice(-2);
      second_str = ("0" + second_str).slice(-2);

      var format_str = "YYYYMMDDhhmmss";
      format_str = format_str.replace("YYYY", year_str);
      format_str = format_str.replace("MM", month_str);
      format_str = format_str.replace("DD", day_str);
      format_str = format_str.replace("hh", hour_str);
      format_str = format_str.replace("mm", minute_str);
      format_str = format_str.replace("ss", second_str);

      return format_str;
    },

    // stringをArrayBufferに変換する
    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff;
      }
      return buf;
    },

    /** 1年間分のデータを作成 */
    async createData() {
      let chartData = {};

      // ラベルの作成とデータ取得
      let dayCount = 0;
      for (var month = 1; month < 13; month++) {
        let dt = new Date(this.year, month, 0);
        let dtYear = dt.getFullYear();
        let dtMonth = dt.getMonth() + 1;

        // ラベル配列中の月ごとの区切り箇所を記録
        const days = dt.getDate();
        this.displayRange[dtMonth]["from"] = dayCount;
        dayCount += days;
        this.displayRange[dtMonth]["to"] = dayCount;

        // ラベルの作成とチャートデータ構造作成
        chartData[dtMonth] = {};
        for (var day = 1; day <= days; day++) {
          chartData[dtMonth][day] = null;

          const dayStr = dtMonth + "/" + day;
          this.allData.labels.push(dayStr);
        }

        /** チャートデータ取得 */
        let todt =
          dtYear +
          "-" +
          ("0" + dtMonth).slice(-2) +
          "-" +
          ("0" + dt.getDate()).slice(-2) +
          "T23:59:59+0900";
        dt.setDate(1);
        let fromdt =
          dtYear +
          "-" +
          ("0" + dtMonth).slice(-2) +
          "-" +
          ("0" + dt.getDate()).slice(-2) +
          "T00:00:00+0900";
        try {
          let params = { from_datetime: fromdt, to_datetime: todt };
          await this.retrieveWeatherHistories(params);
          var monthData = this.getHistories();
          // 取得データを月日毎に分割して保持し直す
          for (const dayData of monthData) {
            let weather_time = new Date(dayData.weather_time);
            chartData[weather_time.getMonth() + 1][weather_time.getDate()] =
              dayData;
          }
        } catch (error) {
          console.log(error);
        }
      }
      this.allData.rowData = chartData;
      this.displayRange[0]["from"] = 0;
      this.displayRange[0]["to"] = dayCount;

      // チャートデータを平均気温など(項目ごと)の配列にする
      let endDate = new Date(this.year, 12, 0, 0, 0, 0, 0);
      for (
        var dateCount = new Date(this.year, 0, 1, 0, 0, 0, 0);
        dateCount.getTime() < endDate.getTime();
        dateCount.setDate(dateCount.getDate() + 1)
      ) {
        const data = chartData[dateCount.getMonth() + 1][dateCount.getDate()];
        if (data) {
          this.allData.temp.data.avg.push(data.temperature_ave);
          this.allData.temp.data.low.push(data.temperature_low);
          this.allData.temp.data.high.push(data.temperature_high);
          this.allData.water.data.max.push(data.precip_intensity);
          this.allData.windy.data.max.push(data.wind_speed);
        } else {
          // データが無くてもその日のデータをnullとして挿入する
          this.allData.temp.data.avg.push(null);
          this.allData.temp.data.low.push(null);
          this.allData.temp.data.high.push(null);
          this.allData.water.data.max.push(null);
          this.allData.windy.data.max.push(null);
        }
      }

      // 表示用データに詰め込む
      this.chartdataTemp.labels = this.allData.labels;
      this.chartdataTemp.datasets[0].data = this.allData.temp.data.avg;
      this.chartdataTemp.datasets[1].data = this.allData.temp.data.low;
      this.chartdataTemp.datasets[2].data = this.allData.temp.data.high;
      this.loadedTemp = true;

      this.chartdataWater.labels = this.allData.labels;
      this.chartdataWater.datasets[0].data = this.allData.water.data.max;
      this.loadedWindy = true;

      this.chartdataWindy.labels = this.allData.labels;
      this.chartdataWindy.datasets[0].data = this.allData.windy.data.max;
      this.loadedWater = true;
    },

    /** グラフに表示しているデータ範囲を切り替える */
    async updateRange() {
      let from = this.displayRange[this.selectRange]["from"];
      let to = this.displayRange[this.selectRange]["to"];

      this.loadedTemp = false;
      this.chartdataTemp.labels = this.allData.labels.slice(from, to);
      this.chartdataTemp.datasets[0].data = this.allData.temp.data.avg.slice(
        from,
        to
      );
      this.chartdataTemp.datasets[1].data = this.allData.temp.data.low.slice(
        from,
        to
      );
      this.chartdataTemp.datasets[2].data = this.allData.temp.data.high.slice(
        from,
        to
      );
      this.$refs.lineChartTemp.updateChart(this.chartdataTemp);
      this.loadedTemp = true;

      this.loadedWindy = false;
      this.chartdataWater.labels = this.allData.labels.slice(from, to);
      this.chartdataWater.datasets[0].data = this.allData.water.data.max.slice(
        from,
        to
      );
      this.$refs.lineChartWater.updateChart(this.chartdataWater);
      this.loadedWindy = true;

      this.loadedWater = false;
      this.chartdataWindy.labels = this.allData.labels.slice(from, to);
      this.chartdataWindy.datasets[0].data = this.allData.windy.data.max.slice(
        from,
        to
      );
      this.$refs.lineChartWindy.updateChart(this.chartdataWindy);
      this.loadedWater = true;
    },
  },
};
</script>

<style lang="scss">
.archivesWeather {
  .div-fixed {
    z-index: 1;
    position: fixed;
    width: calc(100vw - 246px);
    background-color: #f0f3f5;
    // border-bottom: 1px solid #bbb;
  }
  // .header {
  //   margin: 2rem 2rem 1rem 2rem;
  // }
  .button-area {
    width: auto;
    height: calc(100% - 130px);
    position: relative;
    margin-left: 2rem;
    margin-right: 2rem;
    margin-top: 2rem;
    margin-bottom: 10px;

    .btn-submit {
      display: inline-block;
      background: var(--purple);
      font-size: 14px;
      text-align: center;
      width: 200px;
      height: 30px;
      border-radius: 15px;
      color: #fff;
      padding: 6px 10px;
      margin: 1px 6px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
      }
    }
  }

  select {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 50px;
    border-radius: 10px;
    border: solid 1px var(--purple);
    padding: 0 38px 0 16px;
    margin-left: 2rem;
    margin-right: 2rem;
    margin-bottom: 10px;
    font-size: 20px;
    font-weight: bold;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
      calc(100% - 10px) center;
    background-size: 25px 25px;
  }

  select:focus {
    background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
      calc(100% - 10px) center var(--purple-tertiary);
    background-size: 25px 25px;
  }

  .chart-container {
    width: auto;
    box-sizing: border-box;
    margin-left: 2rem;
    margin-right: 2rem;
  }
  .chart-container-canvas {
    position: relative;
    height: 250px;
    top: -10px;
  }
  .chart-date {
    font-weight: normal;
    font-size: 22px;
    margin: 0;
    padding: 0 0 30px 0;
  }
  .chart-date::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_cal.svg") no-repeat center center;
    background-size: 28px 28px;
    padding: 0 28px 0 0;
  }
  #chart-layoutx1 {
    display: grid;
    grid-template-columns: auto;
    width: 100%;
    box-sizing: border-box;
    padding-top: 150px;
  }

  #chart-layoutx2 {
    display: grid;
    grid-template-columns: repeat(
      auto-fit,
      minmax(400px, 2fr) minmax(350px, 1fr)
    );
    width: 100%;
    // justify-content: space-around;
    box-sizing: border-box;
  }

  #chart-layoutx3 {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    width: 100%;
    box-sizing: border-box;
  }

  .chart-area {
    height: auto;
    min-height: 250px;
    margin: 15px 0px;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0px 0px 20px 5px rgb(0 0 0 / 0.1);
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .chart-area p {
    margin: 0;
    padding: 0;
    font-size: 20px;
  }
  .dashboard {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, max-content));
    justify-content: space-around;
    row-gap: 20px;
    column-gap: 50px;
  }
  .dashboard div {
    display: block;
    width: 180px;
    box-sizing: border-box;
    position: relative;
  }
  .dashboard p {
    text-align: center;
    color: #000;
  }
  ul {
    margin: 0;
    padding: 0;
  }
  .pieChart {
    display: block;
    width: 200px; // 180
    height: 220px; // 220
    margin: 10px auto 0;
    position: relative;
    box-sizing: border-box;
    // padding-top: 100px;
    padding-top: 120px;
    text-align: center;
    color: #fdab57;
    font-size: 20px;
  }
  .pieChart span {
    display: block;
    font-size: 56px;
    font-weight: 500;
    color: #fdab57;
    position: absolute;
    // top: 60%;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .pieChart canvas {
    position: absolute;
    // top: 65%;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -55%);
  }

  /* チャート拡大 */

  #chart-bass {
    position: absolute;
    top: 0;
    left: 0;
    display: none;
    background: rgba(0, 0, 0, 0.9);
    width: 100%;
    height: 100vh;
    z-index: 3;
    padding: 60px;
  }
  #chart-bass-frame {
    width: 100%;
    height: 100%;
    padding: 30px;
    border-radius: 20px;
    background: #fff;
  }

  #chart-bass-frame .info {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: top;
  }

  #chart-bass-frame .info p {
    font-size: 20px;
    margin: 0;
    padding: 0 0 20px 15px;
  }

  #chart-bass-frame .info span {
    font-size: 18px;
    margin: 0;
    padding: 0 0 0 20px;
  }

  #closeBtn {
    display: block;
    width: 30px;
    height: 30px;
    background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
    background-size: 30px 30px;
    cursor: pointer;
    transition: 0.1s;
  }
  #closeBtn:active {
    transform: scale(0.9);
    opacity: 0.8;
  }

  #chart-bass.active {
    display: block;
    animation: showChart 0.3s ease 0s;
  }

  #chart-bass .chart-container-canvas {
    position: relative;
    /* width: 100%; */
    height: 80%;
  }

  #chart-bass .calBtn {
    display: block;
    margin: 30px 20px;
    text-align: right;
    color: black;
    cursor: pointer;
    font-size: 14px;
    transition: 0.5s;
  }

  #chart-bass .calBtn::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_cal.svg") no-repeat center center;
    background-size: 20px 20px;
    padding: 0 13px 0 0;
  }

  #chart-bass .calBtn:hover {
    color: #666;
  }

  @keyframes showChart {
    from {
      transform: scale(0.5);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  /* アイコン */

  .ic-chart {
    display: block;
  }
  .ic-chart::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_chart.svg") no-repeat center center;
    background-size: 28px 28px;
    padding: 15px;
  }

  .ic-thermo {
    display: block;
  }
  .ic-thermo::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_thermometer.sun.svg") no-repeat center
      center;
    background-size: 40px 40px;
    padding: 10px;
  }

  .ic-water-level {
    display: block;
  }
  .ic-water-level::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_rain.svg") no-repeat center center;
    background-size: 25px 25px;
    padding: 10px;
  }

  .ic-sunny {
    display: block;
  }
  .ic-sunny::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_sunny.svg") no-repeat center center;
    background-size: 35px 35px;
    padding: 10px;
  }

  .ic-water-temp {
    display: block;
  }
  .ic-water-temp::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_thermometer.svg") no-repeat center
      center;
    background-size: 35px 35px;
    padding: 10px;
  }

  .ic-water {
    display: block;
  }
  .ic-water::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_water_level.svg") no-repeat center
      center;
    background-size: 30px 30px;
    padding: 10px;
  }
  .ic-windy {
    display: block;
  }
  .ic-windy::before {
    white-space: pre;
    content: "   ";
    background: url("~@/assets/icons/ic_strong_wind.svg") no-repeat center
      center;
    background-size: 30px 30px;
    padding: 10px;
  }
  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    // border-bottom: 1px solid;
    // border-image: linear-gradient(
    //   to right,
    //   #fff 0%,
    //   #fff 10%,
    //   #eee 10%,
    //   #eee 100%
    // );
    // border-image-slice: 1;
    // color: var(--purple-secondary);

    // background-color: var(--purple-tertiary);
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    // padding: 0px 0px 0px 10px;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }
  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_folder.svg") no-repeat center center;
  }
}
</style>
